<template>
    <div class="event-wrapper">
        <div class="event-media" v-if="event.medias.length">
            <div class="media" v-if="event.medias.length > 0">
                <div class="image" v-if="media.type.split('/', 1) == 'image'">
                    <img :src="media.url" style="border: 5px solid #fff; -webkit-box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6); box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6); max-width: 40vw; max-height: 80vh;" />
                </div>
                <div class="youtube" v-else-if="media.type == 'video/youtube'">
                    <youtube :video-id="media.filename" width="100%"height="100%" ref="youtube"></youtube>
                </div>
                <div class="video" v-else-if="media.type == 'video/mp4'" style="border: 1px solid green; background: green;">
                    <video-player class="vjs-custom-skin" ref="videoPlayer" :options="playerOptions(media)"></video-player>
                </div>
            </div>
        </div>
        <div class="event-container">
            <div class="event-content">
                <p style="margin: 10px 0;" v-if="contextualization">
                    <b-tag :type="'is-'+event.timeline.color">{{ event.timeline.title }}</b-tag>
                </p>
                <h1 class="title">
                    {{ event.title}}
                </h1>
                <p style="margin: 5px 0; font-style: italic;">
                    {{ format_date(event.start) }} <span v-if="event.end"> &mdash; {{ format_date(event.end) }}</span>
                </p>   
                <p>
                    {{ event.description }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['event', 'media', 'contextualization'],

        methods: {
            playerOptions(media) {
                return {
                    height: '360',
                    sources: [{
                        type: "video/mp4",
                        src: media.url
                    }],
                }
            },
        },
    }
</script>

<style scoped>
    .event-wrapper {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        margin-left: 67px;
        margin-right: 67px;
    }

    .event-media {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
    }

    .image img {
        border: 5px solid #fff;
        -webkit-box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6);
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6);
        max-width: 40vw;
        max-height: 40vh;
        background: #fff;
        width: auto;
        height: auto;
    }

    .event-container {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
    }

    .event-content {
        padding-left: 25px;
        padding-right: 25px;
        text-align: left;
    }

    .youtube, .video {
        width: 40vw;
        height: calc(9/16*40vw);
    }
</style>